import { render, staticRenderFns } from "./ChatLeft.vue?vue&type=template&id=1970c312&"
import script from "./ChatLeft.vue?vue&type=script&lang=js&"
export * from "./ChatLeft.vue?vue&type=script&lang=js&"
import style0 from "./ChatLeft.vue?vue&type=style&index=0&id=1970c312&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports